const { Typography } = require("@mui/material");

const ReceiptFooter = ({ index, length }) => {
  return (
    <Typography
      style={{
        // fontSize: "10px",
        position: "absolute",
        bottom: "10px",
        right: "10px",
      }}
    >
      {index + 1}/{length <= 2 ? length + 1 : length}
    </Typography>
  );
};

export default ReceiptFooter;
